import { normalizeMultiCommentList } from "api/zekay/comments";
import type { ExcursionGroup } from "api/excursions/Excursion.typed";
import type { ExcursionGroupCardUser } from "../../../excursions/shared/utils/excursionPlanningTypes";
import { groupCommentsToMultiComments, type GroupWithLabels } from "./groupModel";

export function mapApiExcursionGroupsToFormState(
  apiGroups: ExcursionGroup[] | undefined,
  nextGroupLocalKey: () => string,
): GroupWithLabels[] {
  if (!apiGroups?.length) return [];

  return apiGroups.map((g) => {
    const fromGroup = g.color && String(g.color).trim() ? g.color : null;
    const fromCustomer =
      g.excursion_customers?.[0]?.color && String(g.excursion_customers[0].color).trim()
        ? g.excursion_customers[0].color
        : null;
    const fromUser =
      g.excursion_users?.[0]?.color && String(g.excursion_users[0].color).trim()
        ? g.excursion_users[0].color
        : null;
    const color = fromGroup ?? fromCustomer ?? fromUser ?? null;
    const users: ExcursionGroupCardUser[] = (g.excursion_users ?? []).map((u) => ({
      id: u.id,
      color: u.color && String(u.color).trim() ? u.color : null,
      comments: normalizeMultiCommentList(u.comments as unknown[] | undefined),
    }));
    const customers = (g.excursion_customers ?? []).map((c) => ({
      id: c.id,
      last_name: undefined,
      first_name: undefined,
      qualification: undefined,
      color: c.color && String(c.color).trim() ? c.color : null,
      emoji: null,
      comments: normalizeMultiCommentList(c.comments as unknown[] | undefined),
    }));
    const p = (g.params as Record<string, unknown>) ?? {};

    return {
      local_key: nextGroupLocalKey(),
      id: g.id,
      users,
      color,
      comments: groupCommentsToMultiComments(g.comments),
      customers,
      customer_id: customers[0]?.id ?? null,
      params: p,
      paramsTemplateId: g.excursion_group_param_id ?? undefined,
    };
  });
}
